<div class="mat-typography mat-body mat-app-background">
  <br>
    <article class="content-section">
      <!-- HEADER -->
      <section>
        <h1>
          {{ data.modalContent.heading || 'Welcome to Blue Cross and Blue Shield of Minnesota and Blue Plus' }}
        </h1>
      </section>

      <!-- SUB-HEADER - seperate content sections to reduce manual configuration before/during/after AEP -->
      <section class="description">

        @if(isChildOnly){
          <div class='sub-header'>
            {{ data.modalContent.childOnlySubheading || "Please type your child's date of birth to proceed" }}
          </div>
        }@else{
          <div class='sub-header'>
            {{ data.modalContent.subheading || 'Please type your date of birth to proceed' }}
          </div>
        }

      </section>

      <!-- Functionality -->
      <div class="content-card">
        <form>
          <div [formGroup] = "form">
            <mat-form-field appearance="outline" class="datepicker-input">
              <mat-label class="label-text">Date Of Birth</mat-label>
              <input matInput
                #entryRef
                placeholder="MM/DD/YYYY"
                [matDatepicker]="picker"
                formControlName="dob"
                name="dob"
                id="dob"
                [min]="dateRange?.min"
                [max]="dateRange?.max"
                required/>
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker">
                </mat-datepicker-toggle>
                <mat-datepicker
                  #picker
                startView='multi-year'></mat-datepicker>
                @if (formControls.dob.errors) {
                  <mat-error>
                    @if (formControls.dob.errors.required) {
                      <span>Required</span>
                    }
                    @if (formControls.dob.errors.maxLength) {
                      <span>Too Long</span>
                    }
                    @if (formControls.dob.errors.incorrectDob) {
                      <span>{{formControls.dob.errors.incorrectDob}}</span>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </form>
          <!-- SUBMIT -->
          <section class="button-container">
            <button class="modal-submit-button" mat-raised-button color="primary" type="submit" [disabled]="form.invalid" (click)="validateDob()">{{data.modalContent.buttonLabel || 'Submit'}}</button>
          </section>
        </div>
      </article>

    </div>